// Agent Marketing - Industries data
import { Home, Landmark, Shield, Users, Building2 } from "lucide-react";

export const industries = [
  {
    slug: "real-estate",
    icon: Home,
    title: "Real Estate Agents",
    lead: "The presence system behind serious real estate professionals.",
    intro: "Clients search you before they call. Listing partners look you up before they refer. Your online presence often decides who gets the appointment.",
    problems: [
      "Weak or missing website",
      "Inconsistent listing graphics",
      "Personal email address",
      "Incomplete Google Business Profile",
      "No follow-up system for buyer and seller inquiries",
      "Social media that looks abandoned between listings",
    ],
    services: ["Branding", "Website", "Google Business Profile", "Listing Templates", "Social Media", "AI Reception", "CRM"],
    outcomes: [
      "You look established next to bigger teams",
      "Every listing is marketed like a signature property",
      "Inquiries are captured, sorted, and followed up",
    ],
  },
  {
    slug: "mortgage",
    icon: Landmark,
    title: "Mortgage Professionals",
    lead: "A trusted presence for mortgage agents and brokers.",
    intro: "Mortgage clients rely on trust more than almost any other decision. Your online presence needs to make that trust feel earned.",
    problems: [
      "Website that reads like a template",
      "No clear explanation of your process",
      "Referral partners cannot easily share your profile",
      "No system for review generation",
      "Inconsistent branding across social and print",
    ],
    services: ["Branding", "Website", "Business Email", "Google Business Profile", "Content Support", "Referral Landing Pages", "CRM"],
    outcomes: [
      "Prospects understand who you are and how you work",
      "Referral partners have something to send",
      "Reviews stack up as social proof",
    ],
  },
  {
    slug: "insurance",
    icon: Shield,
    title: "Insurance Agents",
    lead: "Presence systems for independent insurance agents.",
    intro: "Insurance is a trust product. Your presence needs to communicate stability, service, and reachability.",
    problems: [
      "Carrier-provided pages that look generic",
      "No independent brand identity",
      "Weak local search visibility",
      "No lead capture from your own website",
      "Missed calls when you are with a client",
    ],
    services: ["Branding", "Website", "Google Business Profile", "AI Reception", "CRM", "Content Support"],
    outcomes: [
      "You look independent, established, and reachable",
      "Local search brings you in-market prospects",
      "Missed calls stop turning into lost policies",
    ],
  },
  {
    slug: "recruiting",
    icon: Users,
    title: "Recruiters And Talent Agents",
    lead: "Presence systems for recruiters and talent professionals.",
    intro: "The best candidates and clients research you before responding. Your presence should tell them you are worth their time.",
    problems: [
      "LinkedIn is doing all the work",
      "No branded outbound assets",
      "No credible website to send candidates and clients to",
      "No process content or case studies",
      "Nothing to differentiate you from other recruiters",
    ],
    services: ["Branding", "Website", "Landing Pages", "Content Support", "CRM", "Automation"],
    outcomes: [
      "Candidates take your outreach more seriously",
      "Clients see a firm, not a freelancer",
      "Your pipeline is supported by your own systems",
    ],
  },
  {
    slug: "agencies",
    icon: Building2,
    title: "Agencies And Brokerages",
    lead: "Presence systems for modern agencies, brokerages, and teams.",
    intro: "An agency is only as strong as its weakest agent-facing asset. Consistency across the team is what turns a group of agents into a brand.",
    problems: [
      "Every agent has different graphics",
      "No recruiting page or funnel",
      "Team pages are inconsistent",
      "No per-agent alignment system",
      "Marketing operations are fragmented",
    ],
    services: ["Agency Branding", "Team Website", "Recruiting Funnel", "Per-Agent Add-Ons", "CRM", "Content Systems", "Paid Advertising"],
    outcomes: [
      "The agency reads as one brand",
      "Recruiting becomes systematic",
      "Every agent lifts the parent brand instead of diluting it",
    ],
  },
];

export const findIndustry = (slug) => industries.find((i) => i.slug === slug);
